import { getHost } from '@kk-activity-factory/utils';

const HOST = getHost();

export default {
    updateAttentionStatusAct({ commit, rootState }, params) {
        // const { userId, socialStatus = 0, updateUserDetail = false } = params;
        const { userId, socialStatus = 0 } = params;
        let promise = null;
        // type: 0 取消关注，1 关注
        let type = 1;
        if (socialStatus === 0 || socialStatus === 2) {
            promise = request({
                url: HOST + '/v1/graph/users/h5/{uId}/follow'.replace(/{uId}/, userId),
                headers: {
                    'request-origin': 'web',
                },
                type: 'POST',
            });
        } else {
            type = 0;
            promise = request({
                url: HOST + '/v1/graph/users/{uId}/unfollow'.replace(/{uId}/, userId),
                type: 'POST',
            });
        }
        return promise.then(({ data }) => {
            const { currentRelation } = data;
            // currentRelation: 1 未关注 || 被关注，2 已关注，3 互相关注
            const followSuccess = (currentRelation === 2 || currentRelation === 3) && type === 1;
            const unfollowSuccess = currentRelation === 1 && type === 0;
            if (!followSuccess && !unfollowSuccess) {
                // 关注失败 或 取关失败
                const message = type === 0 ? '取消关注' : '关注';
                throw Error(message + '失败');
            }
            const { userDetail = {} } = rootState.plant || {};
            const { socialStatus = 0 } = userDetail;
            commit(
                'plant/SET_USER_DETAIL',
                {
                    data: {
                        ...userDetail,
                        socialStatus: type ? socialStatus + 1 : socialStatus - 1,
                    },
                },
                { root: true }
            );
            return data;
        });
    },
};
